module.exports = __webpack_public_path__ + "img/car_box.c32f0e92.png";